import { render, staticRenderFns } from "./projectTaskMeetings.vue?vue&type=template&id=53e5903c&scoped=true&"
import script from "./projectTaskMeetings.vue?vue&type=script&lang=js&"
export * from "./projectTaskMeetings.vue?vue&type=script&lang=js&"
import style0 from "./projectTaskMeetings.vue?vue&type=style&index=0&id=53e5903c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e5903c",
  null
  
)

export default component.exports